import { RunObservabilitySeverity, RunWorkerMetrics } from "types/generated";
import { getDuration } from "utils/time";

import { RunObservabilityStatTile, RunObservabilityStatTileComparison } from "./types";

const ratioFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  useGrouping: false,
});

const formatRunObservabilityRatio = (ratio: number) => `${ratioFormatter.format(ratio)}x`;

const DURATION_TOOLTIP =
  "Time the run spent on the worker. This may be lower than the actual run duration, as it excludes server-side overhead, including phases that happen outside the worker such as preparing and finalizing.";

export const toRunObservabilityStatTiles = (
  workerMetrics: RunWorkerMetrics
): RunObservabilityStatTile[] => {
  const tiles: RunObservabilityStatTile[] = [];

  const { seconds, p95Ratio, p95Severity } = workerMetrics.duration;

  if (seconds) {
    let comparison: RunObservabilityStatTileComparison | undefined;

    if (p95Severity === RunObservabilitySeverity.None) {
      comparison = { text: "OK", severity: p95Severity };
    } else if (p95Severity && p95Ratio) {
      comparison = {
        text: `${formatRunObservabilityRatio(p95Ratio)} vs p95`,
        severity: p95Severity,
      };
    }

    const duration = getDuration(seconds, true, false) ?? "0s";

    tiles.push({
      id: "duration",
      label: "Duration",
      value: duration,
      tooltip: DURATION_TOOLTIP,
      comparison,
    });
  }

  const failedResources = workerMetrics.failedResources.count;

  if (failedResources > 0) {
    tiles.push({
      id: "failedResources",
      label: "Failed resources",
      value: String(failedResources),
      valueColor: "danger",
    });
  }

  return tiles;
};
